import React from "react";
import { RichUtils } from "draft-js";
import PropTypes from "prop-types";

import { defaultEditorStyles, styleMap } from "../../utils/editorTexto/editorTexto";
import { convertStyleStringToObject } from "../../utils/string/string";
import EditorTexto from "../../components/EditorTexto";
import ConnectedIntlProvider from "../ConnectedIntlProvider";

const EditorTextoContainer = props => {
  const { onBlur, onChange } = props;
  const handleAtalhosTeclado = (command, editorState) => {
    const currentBlockType = RichUtils.getCurrentBlockType(editorState);
    if (currentBlockType === "table") {
      if (command === "table-tab-next") {
        return this.handleTabInTable("next");
      }
      if (command === "table-tab-previous") {
        return this.handleTabInTable("previous");
      }
      if (command === "split-block") {
        const newState = RichUtils.insertSoftNewline(editorState);
        onChange(newState);
        return "handled";
      }
      if (command === "backspace") {
        const selection = editorState.getSelection();
        if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
          return "handled";
        }
      }
    }

    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      onChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  const handleOnBlur = (event, focus) => {
    if (event.relatedTarget && event.relatedTarget.dataset.autoFocusEditor === "true") {
      setTimeout(focus, 0);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  const customStyleFn = style => {
    const styleNames = style.toJS();

    return styleNames.reduce((styles, styleName) => {
      if (Object.keys(styleMap).find(itemStyle => itemStyle === styleName)) {
        return {};
      }

      let newStyles = { ...styles };
      if (!defaultEditorStyles.includes(styleName)) {
        newStyles = convertStyleStringToObject(styleName, styles);
      }
      return newStyles;
    }, {});
  };

  return (
    <ConnectedIntlProvider>
      <EditorTexto
        handleAtalhosTeclado={handleAtalhosTeclado}
        customStyleFn={customStyleFn}
        handleOnBlur={handleOnBlur}
        {...props}
      />
    </ConnectedIntlProvider>
  );
};

EditorTextoContainer.propTypes = {
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};

export default EditorTextoContainer;
